export default __webpack_public_path__ + "static/media/tablet_image_watermark.f0cf461b.svg";